import { useCallback, useState } from "react"
import http from "../../../../http"
import CadastroOutput from "../../models/CadastroOutput"

export const useAtualizaCadastroPorADM = () => {
    const [resposta, setResposta] = useState({})

    const atualizarCadastroPorADM = useCallback((cadastro_id, inputsCadastro) => {
        let cadastro
        try {
            cadastro = CadastroOutput.create({
                ...inputsCadastro,
                id: cadastro_id,
            })
        } catch (error) {
            setResposta({ data: null, error: { data: error.message } })
            return
        }

        http.put(`/admin/cadastros/${cadastro_id}`, cadastro)
            .then(res => {
                if(res.status === 204) setResposta({ data: 'Cadastro foi atualizado com sucesso', error: null })
            })
            .catch(error => {
                const { response } = error 
                setResposta({ data: null, error: response })
            })
    }, [])

    return [resposta, atualizarCadastroPorADM]
}
